export const getLocationSeoNameByLevel = (level) => {
    if (level < 1 || level > 4) {
        return undefined;
    }
    const locationLevel = ['country', 'region', 'area', 'loc'];
    return window.clientData?.displayAds?.config?.targeting[locationLevel[level - 1]];
};
